import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// react-snap prerenders with this UA; skip runtime-only init during snapshot
const isPrerendering = navigator.userAgent === 'ReactSnap';

if (!isPrerendering) {
  Sentry.init({
    dsn: 'https://86fb75d0a0b8c9ddeff65333cc4b6224@o4511795949404160.ingest.us.sentry.io/4511795960414208',
    dataCollection: {
      // To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#dataCollection
      // userInfo: false,
      // httpBodies: []
    },
  });
}

const rootElement = document.getElementById('root') as HTMLElement;

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Hydrate the prerendered HTML when present; otherwise render fresh
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
